import { useConfig } from 'core/common/hooks';
import { useEvaluatedFlowAttributesContent } from 'core/flow/hooks';
import { asiaCountries, Locales } from 'core/user/entities';
import { Location, LocationOption } from 'core/user/ui';
import { AddressText, AddressWrapper } from './styled';

type AddressProps = {
  className?: string;
};

export const Address = ({ className }: AddressProps) => {
  const config = useConfig();

  const content = useEvaluatedFlowAttributesContent();

  const address = content.address?.value;

  if (!!address) {
    return (
      <AddressText variant="text-body-2xs" color="text.secondary" className={className}>
        {address}
      </AddressText>
    );
  }

  return (
    <AddressWrapper className={className}>
      <Location>
        <LocationOption option={asiaCountries}>
          <AddressText variant="text-body-2xs" color="text.secondary">
            {config.companyNameCN}, {config.addressCN}
          </AddressText>
        </LocationOption>
        <LocationOption option={Locales.US}>
          <AddressText variant="text-body-2xs" color="text.secondary">
            {config.addressUS}
          </AddressText>
        </LocationOption>
        <LocationOption option={Locales.OTHER}>
          <AddressText variant="text-body-2xs" color="text.secondary">
            {config.companyName}, {config.address}
          </AddressText>
        </LocationOption>
      </Location>
    </AddressWrapper>
  );
};
